var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0BB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409 -325) translate(60 229) translate(349 96)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 55c16.569 0 30 13.43 30 30 0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.57 13.431-30 30-30zM15 30L37.5 30M15 45L55 45M15 60L45 60M15 75L39.999 75",
    transform: "translate(46 45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 105H2.94C1.317 105 0 103.684 0 102.058V2.943C0 1.317 1.317 0 2.941 0h50.84c.78 0 1.529.31 2.08.862l23.277 23.277c.552.552.861 1.3.861 2.08v18.782",
    transform: "translate(46 45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 0L55 25 79.999 25M97.067 82.622L84.568 70.121 72.067 82.622M84.567 100.122L84.567 70.121",
    transform: "translate(46 45)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 102
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportNew);
export default __webpack_public_path__ + "static/media/import-new.208bac313be98084ac27e063200dce53.svg";
export { ForwardRef as ReactComponent };